import { useLocation } from 'react-router-dom';

/**
 * usePathname hook - React Router version
 * Returns the current pathname from React Router
 */
function usePathname(): string {
	const location = useLocation();
	return location.pathname;
}

export default usePathname;
